import fetch from '@/utils/fetch'

// ============== 居家课程 ================

// 课程列表
export const coursePushCourseList = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/coursePush/course',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 课程推送
export const coursePushPush = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/coursePush/push',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 课程推送
export const coursePushPushBatch = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/coursePush/pushBatch',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 判断是否显示推送提醒
export const coursePushNotice = (params:any) => {
  return fetch({
    url: '/api-evaluation/admin/evaluation/record/compareSixMonthHadOrNotFinish',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 结束推送
export const coursePushFinish = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/coursePush/finish',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 批量结束推送
export const coursePushFinishMulti = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/coursePush/finishBatch',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡列表
export const punchCardList = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCard/list',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡详情
export const punchCardInfo = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCard/info',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡统计列表
export const punchCardDetailsList = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCard/detailsList',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡统计
export const punchCardStatistics = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCard/statistics',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡统计导出
export const punchCardExport = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCard/detailsList/export',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡统计时间范围
export const punchCardDateType = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCard/statistics/dateType',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡统计列表（按日期查询）
export const punchCardListByDate = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCard/statistics/list',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡统计班级范围
export const punchCardScope = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCard/statistics/scope',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 打卡分析摘要
export const outline = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCardAnalyse/outline',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡分析卡片数据
export const analyseCard = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCardAnalyse/analyseCard',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡分析柱状图数据
export const analyseChart = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCardAnalyse/analyseChart',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 打卡分析柱详情列表
export const analyseDeatilList = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/punchCardAnalyse/detailList',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 积分列表
export const pointList = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/integralRuleRecord/list',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 积分添加
export const pointAdd = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/integralRuleRecord/add',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 积分编辑
export const pointEdit = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/integralRuleRecord/edit',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 积分删除
export const pointDel = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/integralRuleRecord/delete',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 积分详情
export const pointInfo = (params:any) => {
  return fetch({
    url: '/api-home/organize/web/integralRuleRecord/info',
    method: 'post',
    data: {
      ...params
    }
  })
}
